import { render, staticRenderFns } from "./CheckForLatestVersion.vue?vue&type=template&id=141913f8&"
import script from "./CheckForLatestVersion.vue?vue&type=script&lang=js&"
export * from "./CheckForLatestVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141913f8')) {
      api.createRecord('141913f8', component.options)
    } else {
      api.reload('141913f8', component.options)
    }
    module.hot.accept("./CheckForLatestVersion.vue?vue&type=template&id=141913f8&", function () {
      api.rerender('141913f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/generic/CheckForLatestVersion.vue"
export default component.exports